import { UserProfileButton } from "@/base/NewselaGlobalLayoutV2/NavigationBar/UserProfileMenu/UserProfileButton/UserProfileButton";

export { UserProfileButton };
